import * as tslib_1 from "tslib";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd';
import { environment as configs } from 'src/environments/environment';
import { CommonService } from "./common.service";
import * as CryptoJS from "crypto-js";
var IsAuthenticatedGuard = /** @class */ (function () {
    function IsAuthenticatedGuard(httpClient, rt, modalService, CSF) {
        this.httpClient = httpClient;
        this.rt = rt;
        this.modalService = modalService;
        this.CSF = CSF;
        this.that = this;
        this.host = configs['ApiHost'];
        this.warning = function () {
            Swal.fire({
                type: 'warning',
                title: 'Access Denied',
                text: 'You don\'t have permission to asscess this page'
            });
        };
    }
    IsAuthenticatedGuard.prototype.canActivate = function (next, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp, url, segmentUrl, algorithm, key, routeData, isNavigated, isNewTab, pu, nu, m, mh, a, isFirst, userInfo, userRole, userRoleEL;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resp = { isLoggedin: false };
                        url = state.url;
                        segmentUrl = url.split('/');
                        algorithm = 'aes256';
                        key = 'password123456.';
                        routeData = next.data;
                        isNewTab = false;
                        pu = sessionStorage.getItem('PUTR');
                        nu = sessionStorage.getItem('NUTR');
                        //console.log(pu,"==================UTR")
                        //console.log(nu,"==================nUTR")
                        if (this.rt.url != '/') {
                            m = (Math.random() * 100).toString();
                            mh = CryptoJS.HmacSHA1(m, key);
                            sessionStorage.setItem('_FTL', mh);
                            a = next.url;
                            //console.log(a)
                        }
                        isNavigated = (pu != nu);
                        isFirst = sessionStorage.getItem('isFirst');
                        if (isFirst == 'true') {
                            isNewTab = true;
                        }
                        //console.log(isNewTab,isNavigated,this.rt.url,"==================nUTRsdfsdf")
                        if (this.rt.url == '/' && isNavigated == true) {
                            resp['isLoggedin'] = false;
                            localStorage.removeItem('user');
                            localStorage.removeItem('auth-token');
                            localStorage.removeItem('AuthToken');
                            localStorage.removeItem('sid');
                            sessionStorage.removeItem('PUTR');
                            sessionStorage.removeItem('NUTR');
                            sessionStorage.removeItem('isFirst');
                            window.location.href = configs['logoutLink'];
                            //this.rt.navigate(['/login'])
                        }
                        if (this.rt.url == '/' && isNewTab == true) {
                            resp['isLoggedin'] = false;
                            localStorage.removeItem('user');
                            localStorage.removeItem('auth-token');
                            localStorage.removeItem('AuthToken');
                            localStorage.removeItem('sid');
                            sessionStorage.removeItem('PUTR');
                            sessionStorage.removeItem('NUTR');
                            sessionStorage.removeItem('isFirst');
                            window.location.href = configs['logoutLink'];
                        }
                        //console.log(document.referrer,"============== referrer")
                        this.CSF.toggleBusy();
                        return [4 /*yield*/, this.httpClient.get(this.host + '/isloggedin', { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).toPromise()];
                    case 1:
                        resp = _a.sent();
                        this.CSF.toggleBusy();
                        if (resp['isLoggedin'] !== true) {
                            localStorage.removeItem('user');
                            localStorage.removeItem('auth-token');
                            localStorage.removeItem('AuthToken');
                            localStorage.removeItem('sid');
                            sessionStorage.removeItem('PUTR');
                            sessionStorage.removeItem('NUTR');
                            sessionStorage.removeItem('isFirst');
                            window.location.href = configs['logoutLink'];
                        }
                        else {
                            userInfo = JSON.parse(localStorage.getItem('user'));
                            userRole = (userInfo.role != undefined && userInfo.role != "") ? userInfo.role.toString() : 'null';
                            userRoleEL = (userInfo.ELRole != undefined && userInfo.ELRole != "") ? userInfo.ELRole.toString() : 'null';
                            if (routeData.ROLES.indexOf(userRole) > -1 || routeData.ROLES.indexOf(userRoleEL) > -1) {
                                resp['isLoggedin'] = true;
                            }
                            else {
                                this.warning();
                                resp['isLoggedin'] = false;
                            }
                        }
                        return [2 /*return*/, resp['isLoggedin']];
                }
            });
        });
    };
    return IsAuthenticatedGuard;
}());
export { IsAuthenticatedGuard };
